'use client';

import { createContext, useContext } from 'react';

export type NavigationHistoryContextType = {
  /**
   * stores the navigation history as a ref to prevent re-rendering all consumers on every navigation change
   */
  navigationHistory: string[];
  /**
   * stores a boolean flag to trigger a re-render only when it changes (once)
   */
  hasHistory: boolean;
};

export const NavigationHistoryContext =
  createContext<NavigationHistoryContextType>({
    navigationHistory: [],
    hasHistory: false,
  });
/**
 * context accessor that returns back the navigation history and if we have history to go back to
 */
export const useNavigationHistory = () => useContext(NavigationHistoryContext);
